export const TAKE_COMMAND_GREEN = "#188a68";
